import { createSelector } from 'reselect';

const lookupItemBySettingsIdentifier = key => (entityReducer, settings) => {
  const list = entityReducer.get('data'),
    id = settings.getIn(['data', key]);

  return list && id && list.find(item => item.get('id') === parseInt(id, 10));
};

export const selectFeaturedCourse = createSelector(
  state => state.courses.courses,
  state => state.settings.settings,
  lookupItemBySettingsIdentifier('featuredCourseId')
);

export const selectFeaturedMsCourse = createSelector(
  state => state.courses.courses,
  state => state.settings.settings,
  lookupItemBySettingsIdentifier('featuredMsCourseId')
);

export const selectMsCertificationCourse = createSelector(
  state => state.courses.courses,
  state => state.settings.settings,
  lookupItemBySettingsIdentifier('msCertificationCourseId')
);

export const selectSixtyDayCourse = createSelector(
  state => state.courses.courses,
  state => state.settings.settings,
  lookupItemBySettingsIdentifier('sixtyDayCourseId')
);

export const selectFeaturedTvShow = createSelector(
  state => state.tv.shows,
  state => state.settings.settings,
  lookupItemBySettingsIdentifier('featuredShowId')
);

export const selectGiftSubscriptionPrice = createSelector(
  state => state.settings.settings,
  settings => settings && settings.getIn(['data', 'giftSubscriptionPrice'])
);

export const selectPublicCourses = createSelector(
  state => state.courses.courses,
  courses => {
    const courseList = courses.get('data');

    return courseList && courseList.filter(course => course.get('published'));
  }
);



// WEBPACK FOOTER //
// ./src/settings/selectors.js